<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-06-29 15:39:47
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-22 15:57:41
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\index copy.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="page-box">
        <div class="title">一键注册易伙伴电签产品</div>
        <div class="form-box">
            <van-form ref="paramsForm" :show-error="false" error-message-align="right" validate-first>
                <van-field v-model="params.mobile" :rules="rules.mobile" maxlength="11" clearable :border="false"
                    left-icon="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/phone.png" name="手机号" type="tel"
                    placeholder="请输入手机号" />
                <van-field name="验证码" :border="false" clearable maxlength="6" v-model="params.validCode"
                    :rules="rules.validCode"
                    left-icon="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/phobe-01.png" placeholder="验证码">
                    <template #button>
                        <div class="code" size="small" :disabled="flag" color="#f2473d" round v-if="flag">{{ time }}秒后获取
                        </div>
                        <div v-else native-type="button" size="small" color="#f2473d" round @click="goCode">获取验证码</div>
                    </template>
                </van-field>
            </van-form>
            <div class="agreement">
                <van-checkbox v-model="agreementCheck" icon-size="18px" checked-color="#d32537"><span
                        class="agreewith">我已阅读并同意：</span></van-checkbox>
                <div class="agreement-list">
                    <div class="agreement-item" v-for="item in privacypolicyTypeObj" :key="item.privacypolicyId">
                        <span @click="privacypolicy(item.agreementType, item.agreementId)">《{{ item.agreementTitle
                            }}》</span>
                        <span @click="agreement(item.privacypolicyType, item.privacypolicyId)">《{{
                item.privacypolicyTitle
            }}》</span>
                    </div>
                </div>
            </div>
            <div :class="['submit-btn', subMitFlag ? 'showBtn' : '']" @click="onSubmit">
                立即注册
            </div>
        </div>

        <!-- 注册产品状态弹框 -->
        <van-popup v-model="registerPopup" round :style="{ width: '280px' }">
            <div class="prompt">
                <div class="prompt-txt">
                    {{ prompt }}
                </div>
                <div v-if="registerType == 22001" class="close-btn" @click="registerPopup = false">
                    关闭
                </div>
                <div v-else class="btns">
                    <div class="close btn" @click="registerPopup = false">关闭</div>
                    <div class="continue btn" @click="$router.push({ name: 'registerMerchant' })">继续注册</div>
                </div>
            </div>
        </van-popup>


    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { getCode1, validMobile } from '@/api/index';
export default {
    components: {},
    data() {
        return {
            // 表单数据
            params: {
                mobile: "",
                validCode: "",
                referKey: ""
            },
            // 验证码倒计时
            flag: false,
            // 倒计时
            time: 60,
            // 表单规则
            rules: {
                mobile: [
                    { required: true, message: '', },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        message: '',

                    }
                ],
                validCode: [
                    { required: true, message: '', },
                    { max: 6, min: 6, message: '', }
                ],
            },
            // 协议勾选框
            agreementCheck: false,
            // 协议列表
            privacypolicyTypeObj: [{
                agreementTitle: '如意刷用户协议',
                agreementType: 17,
                agreementId: 58,
                privacypolicyTitle: '如意刷隐私政策',
                privacypolicyType: 15,
                privacypolicyId: 57,
            },
            {
                agreementTitle: '吉祥刷用户协议',
                agreementType: 17,
                agreementId: 63,
                privacypolicyTitle: '吉祥刷隐私政策',
                privacypolicyType: 15,
                privacypolicyId: 62,
            },
            {
                agreementTitle: '开心刷用户协议',
                agreementType: 18,
                agreementId: 76,
                privacypolicyTitle: '开心刷隐私政策',
                privacypolicyType: 15,
                privacypolicyId: 75,
            },
            {
                agreementTitle: '幸福刷用户协议',
                agreementType: 25,
                agreementId: 78,
                privacypolicyTitle: '幸福刷隐私政策',
                privacypolicyType: 15,
                privacypolicyId: 77,
            },
            ],
            // 按钮颜色判断
            subMitFlag: false,
            // 注册弹窗
            registerPopup: false,
            //注册状态
            registerType: 0,
            // 注册的提示词
            prompt: "",

        }
    },
    created() {
        window.localStorage.setItem('scanUrl', location.href.split('#')[0])
        if (this.$route.query.referKey) {
            this.params.referKey = this.$route.query.referKey
            localStorage.setItem("oneRegisterReferKey", this.params.referKey)
        } else {
            this.params.referKey = localStorage.getItem("oneRegisterReferKey")
            if (!this.params.referKey) {
                Dialog.alert({
                    title: '温馨提示',
                    message: '该链接缺少参数，请重新复制链接',
                    theme: 'round-button',
                }).then(() => { });
            }
        }
        this.$store.commit('saveReferKey', this.params.referKey)
    },
    watch: {
        params: {
            deep: true,
            handler(val) {
                // 替换为 循环 params 
                if (!this.objIsNull(this.params)) {
                    this.subMitFlag = false
                    return;
                } else {
                    this.subMitFlag = true
                }
            }
        }
    },
    methods: {
        // 获取验证码
        async goCode() {
            if (this.params.mobile.trim().length < 11) {
                Toast('请填写正确的手机号');
                return;
            }
            Toast.loading({
                message: '发送中...',
                forbidClick: true,
                duration: "toast"
            });
            await getCode1(this.params.mobile).then(res => {
                if (res.code != 200) {
                    Toast.clear()
                    Toast(res.msg);
                    return;
                }
                this.time = 60;
                let ti = null;
                this.flag = true;
                ti = setInterval(() => {
                    this.time--;
                    // console.log(this.time);
                    if (this.time <= 1) {
                        clearTimeout(ti);
                        this.flag = false;
                        return;
                    }
                }, 1000);
                Toast.clear()
                Toast('验证码已发送');
            });
        },
        // 用户协议事件
        agreement(id, rid) {
            this.$router.push({ name: "privacypolicy", query: { id: id, rid: rid, title: '隐私政策' } })
        },
        // 隐私政策事件
        privacypolicy(id, rid) {
            this.$router.push({ name: "privacypolicy", query: { id: id, rid: rid, title: '用户协议' } })
        },
        onSubmit() {
            if (!this.agreementCheck) {
                Toast("请阅读并勾选协议")
                return
            }

            this.$refs.paramsForm.validate().then(() => {
                Toast.loading({
                    message: '提交中...',
                    forbidClick: true,
                    duration: "toast"
                });
                // 验证通过
                /*
                    code == 22001     已经全部注册
                    code == 22002     注册部分产品
                    code == 200       新用户 
                */

                validMobile(this.params).then(res => {
                    Toast.clear()
                    this.registerType = res.code;
                    this.prompt = res.msg;
                    localStorage.setItem('merchartInfo', JSON.stringify(res.data))
                    this.$store.commit('setMerchart', res.data)
                    console.log(res);

                    if (res.code == 22001 || res.code == 22002) {
                        this.registerPopup = true;
                        return;
                    } else if (res.code == 200) {
                        // 把 res.data 放入内存内 然后跳转倒 进件页面
                        this.$router.push({ name: "registerMerchant" })
                        return;
                    } else {
                        Toast(res.msg);
                        return;
                    }
                })
            }).catch((e) => {
                console.log(e);
                //验证失败
                Toast(`请正确的填写${e[0].name}`);
            })

        },
        continue() {
            this.$router.push({ name: "registerMerchant" })
        },
    }
}
</script>

<style lang="scss" scoped>
.page-box {
    padding: 50px 30px;
}

.title {
    margin-top: 20px;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
}

.form-box {
    margin-top: 40px;

    .agreement {
        .agreewith {
            font-size: 14px;
            color: #333333;
        }

        .agreement-list {
            margin-top: 10px;
        }

        .agreement-item {
            padding-left: 20px;
            font-size: 14px;
            color: #4D70FE;
        }
    }
}

.submit-btn {
    width: 315px;
    height: 45px;
    margin: auto;
    margin-top: 20px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    background: linear-gradient(107deg, #F42A2A 0%, #C02E2E 100%);
    border-radius: 45px;
    opacity: .5;
}

.showBtn {
    opacity: 1;
}

.van-field {
    padding: 8px 10px;
    background-color: #FAFAFA;
    border-radius: 10px;
    margin: 15px 0;

    ::v-deep .van-icon__image {
        width: 20px;
        height: 20px;
    }
}

.prompt {
    padding: 25px 20px;

    .prompt-txt {
        font-weight: 600;
        margin-bottom: 25px;
        font-size: 16px;
        color: #333333;
    }

    .close-btn {
        width: 238px;
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        background: #D32537;
        border-radius: 23px;
    }

    .btns {
        display: flex;
        justify-content: space-between;

        .btn {
            width: 110px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            border-radius: 26px;
        }

        .close {
            font-size: 16px;
            color: #D32537;
            background-color: #FDF1F1;
        }

        .continue {
            font-size: 16px;
            color: #FFFFFF;
            background-color: #CE292F;
        }
    }
}
</style>
